module.exports = __webpack_public_path__ + "assets/images/scroll-down-icon.svg?v=f9cc87c6";